
/**
 *根据数据条数与每页多少条数据计算页数 
 * totalnum 数据条数
 * limit 每页多少条
 */

 // 引入uuid库
const { v4: uuidv4 } = require('uuid');

 
function pageCount (totalnum,limit){
    return totalnum > 0 ? ((totalnum < limit) ? 1 : ((totalnum % limit) ? (parseInt(totalnum / limit) + 1) : (totalnum / limit))) : 0;
}


 /**
   * 防抖
   * @param {function} fn 执行函数
   * @param {number} wait 等待时间，毫秒
   * @param {boolean} immediate 是否立即执行
   */
function debounce(fn, wait, immediate) {
    let timeout; // 局部全局变量
    return function (...args) {
      let context = this;
      if (timeout) clearTimeout(timeout); // 清除计时器，但是timeout本身还在，只是不会在执行
 
      if (immediate) { // 总是执行第一次操作
        let callNow = !timeout; // 第一次为true
        // 多次操作，timeout初始化，多次触发只有当wait等待时间结束timeout才为空
        timeout = setTimeout(function () {
          timeout = null;
        }, wait);
        // 第一次为true, 执行
        if (callNow) fn.apply(context, args);
      } else { // 总是执行最后一次操作
        timeout = setTimeout(function () {
          fn.apply(context, args);
        }, wait);
      }
    };
}



//字符转float
function strToFloat(value)
{
    if (value==null || value =="")
    {
        value = "0";
    }
    return parseFloat(value);
}

//这符转整型
function strToInt(value) {
    if (value == null || value == "") {
        value = "0";
    }
    return parseInt(value);
}



function objToStr(value){

    if (value==null) {
        return "";
    } else {
        return value;
    }

}


function boolToStr(value) {

    if (value == true) {
        return "1"
    } else {
        return "0";
    }
}


//对象转查询    
function objectToQuery() {
    
    let obj = arguments[0];
    let prefix = arguments[1];
    if (typeof obj !== "object") return "";
    const attrs = Object.keys(obj);
    return attrs.reduce((query, attr, index) => {
        if (typeof obj[attr] === "object") {
            const subPrefix = prefix ? `${prefix}[${attr}]` : attr;
            if (obj[attr] != null) {
            query += this.objectToQuery(obj[attr], subPrefix);
            }
            
        } else {
            if (prefix) {
                query += `${prefix}[${attr}]=${obj[attr]}`;
            } else {
                query += `${attr}=${obj[attr]}`;
            }
        }
        if (index !== attrs.length - 1) query += "&";
        return query;
    }, "");
}


//生成分享口令
function getShareToken(length) {
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var shareToken = '';
  
    for (var i = 0; i < length; i++) {
      var randomIndex = Math.floor(Math.random() * characters.length);
      var randomChar = characters.charAt(randomIndex);
      shareToken += randomChar;
    }
  
    return shareToken;
}
  

function keepContent(content, substr) {
    let result = [];
    let newarr = content.split("<p>");
    newarr.forEach(item => {
        if (item.indexOf("<p ")>= 0) {
            let arr1 = item.split("<p "); 
            arr1.forEach(item1 => {
                if (item1.indexOf(substr)>= 0) {
                    result.push('<p ' + item1);
                }                           
            });                        
        } else {
            if (item.indexOf(substr)>= 0) {
                result.push('<p>' + item);
            }
        }
    });      
    return result.join("");
}


function sortContent(content) {
    let result = [];
    let newarr = content.split("<p>");
    for (var i= newarr.length-1; i>= 0; i--) {
        let item = newarr[i];
        if (objToStr(item) != "") {
            if (item.indexOf("<p ")>= 0) {
                let arr1 = item.split("<p "); 
                arr1.forEach(item1 => {
                    result.push('<p ' + item1);                         
                });                        
            } else {
                result.push('<p>' + item);
            }
        }
    }
    return result.join("");
}


function isMobile () {
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      return true // 手机端
    } else {
      return false // alert('PC端')
    }
  }

function isEmpty(value) {
    return (value==null || value=="" || value=="null");
}

function strCount(str1, str2) {
    // 将字符串转化为正则表达式，并添加全局匹配标志
    const regex = new RegExp(str1.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
    // 使用match方法计算出现次数
    const matches = str2.match(regex);
    return matches ? matches.length : 0;
}



function getUUID() {
    // 生成UUID
    const uuid = uuidv4();
    console.log(uuid);
    return uuid;
}

 
export  {
    pageCount,debounce,strToFloat,strToInt,objToStr,boolToStr,objectToQuery,getShareToken,keepContent,isMobile,sortContent,isEmpty,strCount,getUUID
}



// WEBPACK FOOTER //
// ./src/utils/sysUtils.js